type NormalizedObject = {
	[key: string]: any;
};

export const normalizeObjectKeys = (data: NormalizedObject): NormalizedObject => {
	return Object.keys(data).reduce((acc: NormalizedObject, key: string) => {
		acc[key.toLowerCase()] = data[key];
		return acc;
	}, {});
};
